(function () {
  function init(root) {
    var section = (root || document).querySelector('[data-smelu-material-story]');
    if (!section) return;

    var svgLayers = section.querySelectorAll('.smelu-material-svg__layer[data-layer]');
    var tabs      = section.querySelectorAll('.smelu-mat__tab[data-layer]');
    var cards     = section.querySelectorAll('.smelu-mat__detail-card[data-layer]');

    if (!tabs.length) return;

    /* Touched-Flag: sobald User irgendwo aktiv interagiert, stoppt der Pulse-Hint */
    function markTouched() {
      section.setAttribute('data-tabs-touched', 'true');
    }

    function activate(layerId) {
      /* SVG cutaway rects: data-active attribute */
      svgLayers.forEach(function (l) {
        l.dataset.active = l.dataset.layer === layerId ? 'true' : 'false';
      });
      /* Pill tabs */
      tabs.forEach(function (t) {
        var on = t.dataset.layer === layerId;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      /* Detail cards */
      cards.forEach(function (c) {
        var on = c.dataset.layer === layerId;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    }

    /* SVG layer rect clicks (pointer users) */
    svgLayers.forEach(function (l) {
      l.addEventListener('click', function () { markTouched(); activate(l.dataset.layer); });
    });

    /* Tab clicks + keyboard */
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { markTouched(); activate(t.dataset.layer); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          markTouched();
          activate(t.dataset.layer);
        }
      });
    });

    /* Default: first tab rendered = layer 01 (Topcoat, oberste Schicht) */
    activate(tabs[0].dataset.layer);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
